<template>
  <swiper 
    :modules="modules" 
    :pagination="{clickable: true}"
    :navigation="true"
    :autoplay="{delay: 2500}"
  >
    <swiper-slide><img src="../assets/01.jpg" alt=""></swiper-slide>
    <swiper-slide><img src="../assets/02.jpg" alt=""></swiper-slide>
    <swiper-slide><img src="../assets/03.jpg" alt=""></swiper-slide>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  setup() {
    const modules = [Pagination, Navigation, Autoplay];
    return { modules };
  }
}
</script>
<style scoped>
img {
  width: 100%;
}
</style>